export enum LegendBorderStyleTypes {
    ROUND = "ROUND",
    SQUARE = "SQUARE"
}